import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../..';

export const selectAppContext = (state: RootState) => state.context;

export const selectDividedEachPage = createSelector(selectAppContext, ctx => ctx.dividedEachPage);
export const selectSessionId = createSelector(selectAppContext, ctx => ctx.sessionId);
export const selectAppStep = createSelector(selectAppContext, ctx => ctx.appStep);
export const selectTutorial = createSelector(selectAppContext, ctx => ctx.showTutorial);
export const selectUploadErrorsModal = createSelector(selectAppContext, ctx => ctx.errors);
export const selectEnvironment = createSelector(selectAppContext, ctx => ctx.environment);
export const selectProgram = createSelector(selectAppContext, ctx => ctx.program);
export const selectProgramMode = createSelector(selectAppContext, ctx => ctx.programMode);
